import {
  addPlayerLibraryIfNotExists,
  jwBaseUrl,
  waitForJwPlayer,
} from './player';
import { setupPlayer } from './setup';
import * as constants from './constants';
import { hasConsent } from './consent';
import log from './utils/logging';
import { getVideoData } from './state';
import { getVideoConfig } from './config';

// Updates playlist to include video thumbnails.
const updateThumbnailToConfig = (mediaID) => {
  const mediaFile = `https://cdn.jwplayer.com/v2/media/${mediaID}/poster`;
  const getPlaylistFile = `https://content.jwplatform.com/videos/${mediaID}-${constants.jwUserId}.mp4`;

  return [
    {
      file: getPlaylistFile,
      mediaid: mediaID,
      image: `${mediaFile}.jpg?width=720`,
      images: [
        {
          src: `${mediaFile}.mp4?width=320`,
          width: 320,
          type: 'video/mp4',
        },
        {
          src: `${mediaFile}.mp4?width=640`,
          width: 640,
          type: 'video/mp4',
        },
      ],
    },
  ];
};

/**
 * Replace video placeholders with videos.
 *
 * @param {Document | Element} content
 * @returns {any}
 */
export function initializePlaceholders(content = window.document) {
  const onNewContentLoaded = async () => {
    // Get video configs from placeholders
    getVideoConfig(content);
    const { configData = [], playerIDs = [] } = getVideoData();

    const replacePlaceholder = async (data) => {
      const {
        id,
        playerID,
        config: { enableMovingThumbnail },
        config,
        isTop,
        youplayId,
        placeholder,
      } = data;

      const player = await setupPlayer(
        {
          mediaID: id,
          playerID,
          containerEl: placeholder,
          isTop,
          wasYouplay: youplayId !== null,
        },
        {
          playlist: enableMovingThumbnail
            ? updateThumbnailToConfig(id)
            : `${jwBaseUrl}v2/media/${id}`,
          ...config,
        },
      ).catch((err) => console.log(err));
      return player;
    };

    // NOTE: We could use the return value of getCookieLawConsent to see if we actually have
    // sufficiient permissions for JW and the ads we show to the user.
    log.info('Awaiting GDPR Consent...');
    await hasConsent();
    log.info('...got consent!');
    await Promise.all(
      playerIDs.map((id) => {
        addPlayerLibraryIfNotExists(id);
      }),
    );

    await waitForJwPlayer().catch((err) => console.log(err));

    return Promise.all(configData.map(replacePlaceholder));
  };

  return onNewContentLoaded;
}
